import { persistQueryClient } from "@tanstack/query-persist-client-core";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { getQueryClient } from "@verbleif/lib/src/composables/Query/queryClient";
import { localeState } from "@verbleif/lib/src/translations/localeState";
import { localePersistBuster } from "@verbleif/shared/src/composables/Query/useLocaleQueryReset";

const persister = createSyncStoragePersister({
  storage: window.localStorage,
  key: "vb-query-cache",
  throttleTime: 1000,
});

const [, restorePersistedQueries] = persistQueryClient({
  queryClient: getQueryClient() as unknown as Parameters<typeof persistQueryClient>[0]["queryClient"],
  persister,
  // Locale at page load. Later saves keep this buster, so the next load in another language drops them.
  buster: localePersistBuster(localeState.value),
  maxAge: 5 * 60_000,
  dehydrateOptions: {
    shouldDehydrateQuery: q => q.meta?.persist === true,
  },
});

export { restorePersistedQueries };

export function clearPersistedQueryCache(): void {
  persister.removeClient();
}
